var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-pagination',{staticClass:"mb-0",attrs:{"total-rows":_vm.total,"per-page":_vm.perPage,"first-text":"First","prev-text":"Prev","next-text":"Next","last-text":"Last"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }